var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"notFound"},[_c('img',{attrs:{"src":require("assets/slide/notFound2.png"),"alt":_vm.$t('k_343236')}}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('k_343236')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }